import React from 'react';
import { CircleLoader } from '..';
import { Screen } from '../Screen';

type Props = {
  testID?:string;
}

export const Loading: React.FC<Props> = ({ testID='Loading', }) => {
return <Screen center>
    <CircleLoader />
</Screen>
}